import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

export const Accordion = ({ children }) => {
  return <div className="space-y-2">{children}</div>;
};

export const AccordionItem = ({
  title,
  children,
  buttonClassName = '',
  titleClassName = '',
  contentClassName = '',
  iconClassName = '',
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border-b border-borderDefault">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={[
          'flex items-center justify-between w-full p-4 font-semibold text-left transition hover:bg-primary/10',
          buttonClassName,
        ].join(' ')}
      >
        <span className={titleClassName}>{title}</span>
        <ChevronDown
          className={[
            'w-5 h-5 transition-transform',
            isOpen ? 'transform rotate-180' : '',
            iconClassName,
          ].join(' ')}
        />
      </button>
      {isOpen && <div className={['p-4', contentClassName].join(' ')}>{children}</div>}
    </div>
  );
};
